interface PageLoaderProps {
}

const PageLoader = () => {
    return (<div style={{position: "absolute", top: "50%", left: "50%"}}>
        <img alt={'loader'} style={{width: 50, height: 50}} src={"./loader.svg"}/>
    </div>);
}
export default PageLoader;
